module.exports = __webpack_public_path__ + "static/img/hhd.f3380ff0.jpg";